import { useTranslation } from 'react-i18next'

import Text from '../../../Text'
import {
  getEntityTabAttributeDisplayValue,
  getEntityTabAttributeLabel,
  isEntityTabAttributeValueMissing,
} from '../EntityTabAttributes.utils'

import * as styles from './EntityTabAttributesEntry.module.css'

function EntityTabAttributesEntry({ label, value }) {
  const { i18n, t } = useTranslation()

  const isMissing = isEntityTabAttributeValueMissing(value)

  return (
    <div className={styles.item}>
      <Text isSecondary className={styles.label}>
        {getEntityTabAttributeLabel({ i18n, label, t })}
      </Text>
      <div className={styles.valueColumn}>
        <Text className={isMissing ? styles.placeholder : styles.value}>
          {getEntityTabAttributeDisplayValue({ t, value })}
        </Text>
      </div>
    </div>
  )
}

export default EntityTabAttributesEntry
